import { Meta } from 'util/metaPath'
import { RuleFunction } from 'util/validation'

import { msg } from '..'

export const igualA = <T>(compareKey: Meta<T>, inputName: string, compareName: string): RuleFunction => (
  inputValue,
  allValues
) => (allValues?.[compareKey.absolutePath()] !== inputValue ? msg('igualA', inputValue, inputName, compareName) : null)
